import {Component} from "@angular/core";
import {RouteConfig, ROUTER_DIRECTIVES} from "@angular/router-deprecated";
import {asyncRoute} from "./shared/utils/route.util";

@Component({
  selector: 'app',
  directives: [ROUTER_DIRECTIVES],
  template: '<router-outlet></router-outlet>'
})
@RouteConfig([
  asyncRoute('/...', 'Website', (resolve)=>require(['./website/website.component'], resolve), true),
  asyncRoute('/backoffice/...', 'BackOffice', (resolve)=>require(['./backoffice/backoffice.component'], resolve)),
  asyncRoute('/owners/...', 'Owners', (resolve)=>require(['./owners/owners.component'], resolve)),
])
export class App {
}



/** WEBPACK FOOTER **
 ** ./client/app/app.component.ts
 **/